<div class="auth-container w-100 d-flex flex-column">
  <header class="d-flex justify-content-between align-items-center w-100 py-4 px-4">
    <img src="assets/icons/avyna/logo.svg" [alt]="'backoffice.shell.logo_alt' | translate" class="logo" />
  </header>

  <main class="main-content d-flex align-items-center justify-content-center px-3">
    <router-outlet />
  </main>

  <footer class="w-100 px-4 pb-2 d-flex align-items-center gap-3">
    <av-theme-toggle></av-theme-toggle>
    <span class="footer-text">{{
      'backoffice.auth.footer' | translate: { version: version }
    }}</span>
  </footer>
</div>
